import { FileTextIcon, ZapIcon, BotIcon, SmartphoneIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF & Mobile Access'
}, {
  icon: ZapIcon,
  label: 'Instant Download'
}, {
  icon: BotIcon,
  label: 'Works with ChatGPT, Claude, Gemini & DeepSeek'
}, {
  icon: SmartphoneIcon,
  label: 'Optimized for MDT & Mobile'
}];
export const stats = [{
  value: '500+',
  label: 'Satisfied Officers'
}, {
  value: '6+4',
  label: 'Volumes + Bonuses'
}, {
  value: '99%',
  label: 'Success Rate'
}, {
  value: '4.9/5',
  label: '⭐ Global Rating'
}];
